<div fxLayout="row" fxLayoutAlign="space-between center"
     class="w-100 bc-secondary-yellow-100 radius-12 pl-16 pr-16"
     [class.pt-8]="!!buttonLabel"
     [class.pb-8]="!!buttonLabel"
     [class.pt-12]="!buttonLabel"
     [class.pb-12]="!buttonLabel">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
        <ui-kit-svg class="i-24 c-secondary-yellow-800" name="ic_warning"/>
        <div class="t3 c-primary-gray-900">
            @if (accentText) {<span class="c-secondary-yellow-800">{{ accentText | translate }}</span>&ngsp;}{{ warningText | translate }}
        </div>
    </div>
    @if (buttonLabel) {
        <ui-kit-button type="white"
                       size="small"
                       [label]="buttonLabel | translate"
                       (clickListener)="clickListener.emit()"/>
    }
</div>
